import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'//引入vue-resource插件http请求
//组件模块
import Index from './pages/Index'
import chapter from './pages/Chapter'
import contents from './pages/Contents'
Vue.use(Router)
Vue.use(VueResource)
//在路由的请求中如此设置
Vue.http.options.emulateJSON = true
Vue.http.options.xhr = { withCredentials: true }
Vue.http.options.crossOrigin = true
Vue.http.options.emulateHTTP = true
Vue.http.options.headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
}
export default new Router({
   // mode: 'history',
    routes: [
      { path: '/Index', name: 'index', component: Index },
      { path: '/Chapter', name: 'chapter', component: chapter },
      { path:'/SubChapter',name: 'SubChapter', component: chapter},
      { path: '/Content', name: 'contents', component: contents },
      {path:'/',redirect:'/Index'}
    ]
  })
  